import React, { Component } from 'react';
// import classNames from 'classnames'
import styles from './index.css';

// import {LangChangeEventContext} from '../../contexts/LangContext';

import MainAbout   from '../../components/MainAbout';
import MainHistory from '../../components/MainHistory';
import MainKitchen from '../../components/MainKitchen';
import MainAboutMobile   from '../../components/MainAboutMobile';
import MainHistoryMobile from '../../components/MainHistoryMobile';
import MainKitchenMobile from '../../components/MainKitchenMobile';

export default class Main extends Component {  
  getHeightHistory = height =>{
    this.props.getHeightHistory(height);
  }
  getHeightKitchen = height =>{
    this.props.getHeightKitchen(height);
  }
  handleScrollDown = () =>{
    this.props.handleScrollDown();
  }
  mobile(){
    if(document.documentElement.clientWidth < 1025) return true;
    return false;
  }
  render() {
    return (
      <div className={styles['contentIndex']} >  
        {!this.mobile()&&<MainAbout   ADMIN_URL = {this.props.ADMIN_URL} steps={this.props.steps} bg={this.props.data.bgA} gallery={this.props.data.galA}   hideArrow={this.props.hideArrowAbout}  handleScrollDown={this.handleScrollDown}/>}
        {!this.mobile()&&<MainHistory ADMIN_URL = {this.props.ADMIN_URL} steps={this.props.steps} bg={this.props.data.bgH} gallery1={this.props.data.galH1} gallery2={this.props.data.galH2} getHeightHistory={this.getHeightHistory} hideArrow={this.props.hideArrowHistory}  handleScrollDown={this.handleScrollDown}/>}
        {!this.mobile()&&<MainKitchen ADMIN_URL = {this.props.ADMIN_URL} steps={this.props.steps} bg={this.props.data.bgK} gallery1={this.props.data.galK1} gallery2={this.props.data.galK2} video={this.props.data.videoK} getHeightKitchen={this.getHeightKitchen} valueScroll={this.props.valueScroll}/>}
        { this.mobile()&&<MainAboutMobile    ADMIN_URL = {this.props.ADMIN_URL} bg={this.props.data.bgA} gallery={this.props.data.galA}/>}
        { this.mobile()&&<MainHistoryMobile  ADMIN_URL = {this.props.ADMIN_URL} bg={this.props.data.bgH} gallery1={this.props.data.galH1} gallery2={this.props.data.galH2} />}
        { this.mobile()&&<MainKitchenMobile  ADMIN_URL = {this.props.ADMIN_URL} bg={this.props.data.bgK} gallery1={this.props.data.galK1} gallery2={this.props.data.galK2} video={this.props.data.videoK}/>}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MainContent/index.js